import { Accordion, AccordionTab } from 'primereact/accordion';
import Headers from '../Headers/headers';
import Nature_origin from '../nature and origin/nature_and_origin';
import Specifications from '../specification/specifications';
import Reguletions from '../reguletions/ragulations';
import Blacklist from '../blacklist/blacklist';
import Conditions_to_use from '../contitions to use/conditions_to_use';
import Store_Conditions from '../contitions to use/storage_condition_shelf_life';
import Applications from '../contitions to use/applications';
import Risk from '../risk/risk';
import Risk_code_tables from '../risk/risk_code_tables';
import Tolerance_and_Substantion from '../tolerance_and_substantiation/tolerance_and_substantiation';
import { Flex, Spinner, useConst } from '@chakra-ui/react';
import { useContext, useEffect } from 'react';
import { Home_context } from '../../context/home_context';
import { Link, useParams } from 'react-router-dom';
import Suppliers from '../Suppliers/suppliers_page.jsx';
import Suppliers_page from '../Suppliers/suppliers_page.jsx';
import Identified_ingredients from '../identified_ingredients/identified_ingredients.jsx';


export default function Report() {
  const { hendleApicall_get_report, report_data_state } =
    useContext(Home_context);
  // let {report_id}=useParams()

  // useEffect(() => {
  //   console.log('**', report_id);
  // }, [report_id]);
  console.log('from report', report_data_state);
  return report_data_state.report_data_state_loading ? (
    <div className="w-[80vw] flex justify-center">
      <Spinner />
    </div>
  ) : report_data_state.report_data &&
    Object.keys(report_data_state.report_data)?.length == 0 ? (
    <div className="flex flex-col items-center justify-center min-h-[100vh]  text-center translate-y-[-50px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-24 w-24 text-gray-400 mb-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 13h6m2 0a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <h2 className="text-2xl font-semibold text-gray-700">
        No Data Available
      </h2>
      <p className="text-gray-500 mt-2">
        There’s nothing to display here. Try updating your filters or check back
        later.
      </p>
      <Link to={'/home'}>
        <button className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700">
          Back
        </button>
      </Link>
    </div>
  ) : (
    <div className="report_id_page">
      <div>
        <Headers />
      </div>
      <div>
        <Identified_ingredients/>
      </div>
      <div className="between_header_padding">
        <Nature_origin />
      </div>
      {/* <div className="between_header_padding">
        <Specifications />
      </div> */}
      <div className="between_header_padding">
        <Reguletions />
      </div>
      <div className="between_header_padding">
        <Blacklist />
      </div>

      <div className="between_header_padding">
        <Conditions_to_use />
        <Store_Conditions />
        <Applications />
      </div>

      <div className="between_header_padding">
        <Tolerance_and_Substantion />
      </div>
      <div className="between_header_padding">
        <Suppliers_page/>
      </div>

      {/* <div className="card"> */}
      {/* <Accordion activeIndex={0}> */}
      {/* <AccordionTab
            header={
              <span className="page_headers  font-semibold  header_color ">
                REGULATION
              </span>
            }
          >
            <Reguletions />
          </AccordionTab> */}
      {/* <AccordionTab
            header={
              <span className="page_headers  font-semibold header_color ">
                BRAND RESTRICTION
              </span>
            }
          >
            <Blacklist />
          </AccordionTab> */}
      {/* <AccordionTab
            header={
              <span className="page_headers  font-semibold header_color ">
                BEST USE:
              </span>
            }
          >
            <Conditions_to_use />
            <Store_Conditions />
            <Applications />
          </AccordionTab> */}
      {/* <AccordionTab
            header={
              <span className="page_headers  font-semibold header_color ">
                RISKS: (GLOBALLY HARMONIZED SYSTEM GHS)
              </span>
            }
          >
            <Risk />
            <Risk_code_tables />
          </AccordionTab> */}

      {/* <AccordionTab
            header={
              <span className="page_headers  font-semibold header_color ">
                TOLERANCE & SUBSTANTIATION
              </span>
            }
          >
            <Tolerance_and_Substantion />
          </AccordionTab> */}
      {/* </Accordion> */}
      {/* </div> */}
    </div>
  );
}
